// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M2 2V4H4V22.0806L7.46605 19.3078L9.75 21.338L12 19.338L14.25 21.338L16.5339 19.3078L20 22.0806V4H22V2H2ZM16 9H8V7H16V9ZM9 13V11H15V13H9Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-bill-filled')
export default class BillFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'bill-filled',
    }
  }
}
